const aboutContent: string = 'Electronic Musician | Los Angeles, CA';

export default aboutContent;
